import { createTheme } from '@mui/material/styles';
import { viVN } from '@mui/material/locale';

declare module '@mui/material/styles' {
	interface Theme {
		status: {
			danger: string;
		};
	}

	interface ThemeOptions {
		status?: {
			danger?: string;
		};
	}
}

// Desktop scale factor: reduce UI to 90% on screens >= 900px
// Uses rem-based spacing so it scales with root font-size
const DESKTOP_SCALE = 0.9;
const BASE_SPACING_REM = 0.5; // 0.5rem = 8px at 16px root (MUI default)

export const theme = createTheme({
	spacing: (factor: number) => `${factor * BASE_SPACING_REM}rem`,
	palette: {
		mode: 'light',
		primary: {
			main: '#1976d2',
			light: '#42a5f5',
			dark: '#1565c0',
		},
		secondary: {
			main: '#dc004e',
			light: '#ff5983',
			dark: '#9a0036',
		},
		background: {
			default: '#fafafa',
			paper: '#ffffff',
		},
	},
	typography: {
		fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
		h1: {
			fontSize: '2.5rem',
			fontWeight: 600,
		},
		h2: {
			fontSize: '2rem',
			fontWeight: 600,
		},
		h3: {
			fontSize: '1.75rem',
			fontWeight: 600,
		},
		h4: {
			fontSize: '1.5rem',
			fontWeight: 500,
		},
		h5: {
			fontSize: '1.25rem',
			fontWeight: 500,
		},
		h6: {
			fontSize: '1rem',
			fontWeight: 500,
		},
	},
	components: {
		MuiCssBaseline: {
			styleOverrides: {
				html: {
					'@media (min-width: 900px)': {
						fontSize: `${DESKTOP_SCALE * 100}%`,
					},
				},
			},
		},
		MuiButton: {
			styleOverrides: {
				root: {
					textTransform: 'none',
					borderRadius: 8,
				},
			},
		},
		MuiCard: {
			styleOverrides: {
				root: {
					borderRadius: 12,
					boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
				},
			},
		},
		MuiPaper: {
			styleOverrides: {
				root: {
					borderRadius: 12,
				},
			},
		},
	},
	status: {
		danger: '#e53e3e',
	},
}, viVN);